<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card-title class="sub-title ma-0 pa-0">
          Average Summary
        </v-card-title>
      </v-col>
    </v-row>
    <v-layout row wrap class="mt-0">
      <v-flex md2 sm6 xs12 pa-3>
        <v-card class="small-box" dark color="#363636" min-height="145px">
          <v-card-title class="title card-title one-line">Activating</v-card-title>
          <v-card-text>
            <h3>{{totalValues.activating}} days</h3>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md2 sm6 xs12 pa-3>
        <v-card class="small-box" dark color="#363636" min-height="145px">
          <v-card-title class="title card-title one-line">Pairing</v-card-title>
          <v-card-text>
            <h3>{{totalValues.pairing}} days</h3>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md2 sm6 xs12 pa-3>
        <v-card class="small-box" dark color="#363636" min-height="145px">
          <v-card-title class="title card-title one-line">Cocreating</v-card-title>
          <v-card-text>
            <h3>{{totalValues.cocreating}} days</h3>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md3 sm6 xs12 pa-3>
        <v-card class="small-box" dark color="#363636" min-height="145px">
          <v-card-title class="title card-title one-line">Complete</v-card-title>
          <v-card-text>
            <h3>{{totalValues.complete}} days</h3>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md3 sm6 xs12 pa-3>
        <v-card class="small-box" dark color="#363636" min-height="145px">
          <v-card-title class="title card-title one-line">Average Duration</v-card-title>
          <v-card-text>
            <h3>{{totalValues.duration}} days</h3>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  name: 'AverageBoxes',
  props: ['totalValues']
}
</script>



// WEBPACK FOOTER //
// AverageBoxes.vue?aa58cb54